import { Observable } from 'rxjs/Observable';
// import { Subject } from 'rxjs/Rx';
// import { resolve } from 'dns';
import { Injectable } from '@angular/core';

import { tResourceReadings } from './glowadmin.typings';

@Injectable()
export class CacheService {

    cachedData: any = {};
    constructor(){

    }

    get(key: string): Promise<any> {
        console.log("cachedData")
        console.log(this.cachedData)
        console.log(key)
        return new Promise( (resolve)=> { 
            console.log("cachedData")
            console.log(this.cachedData)
            console.log(key)

            if (this.cachedData.hasOwnProperty(key)) {
                return resolve(this.cachedData[key]); 
            } else {
                return resolve();
            }
        }); 

    }

    /**
     * Sets the value with key in the cache
     * Notifies all observers of the new value
     */
    set(key: string, value: any): void {
        this.cachedData[key] = value;
    }

    /**
     * Checks if the a key exists in cache
     */
    has(key: string): boolean {
        return this.cachedData.hasOwnProperty(key);
    }

    //clear Cache at log out events
    clear(): void {
        this.cachedData = {};
    }

    //TO DO. make more sophisticated.  Add a cleaner.
}